import React, { useEffect, useState } from 'react'
import TopBar from '../Layouts/TopBar';
import SideEdit from '../Layouts/SideEdit';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import instance from '../Config/AxiosConfig';
import Cookies from 'js-cookie';

function EditProfil() {
  const { id } = useParams();
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const handleLogout = () => {
    Cookies.remove('token');
    Cookies.remove('response');
    Cookies.remove('userId')
    localStorage.removeItem('formNumber')
    localStorage.removeItem('userId')
    window.location.href = '/';
  };
  const [loading, setLoading] = useState(true); // Pour indiquer que les données sont en cours de chargement

  // Ajouter des états pour chaque champ
  const [userdetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    universityName: '',
    // username: '',
    email: '',
    // phoneNumber: '',
    aboutDescription: '',
    profilePicture: null,
  });


  useEffect(() => {
    // Charger les détails de l'utilisateur depuis l'API
    instance.get(`/users/get/${id}`)
      .then(res => {
        setUserDetails(res.data);
        setLoading(false); // Arrêter l'indicateur de chargement
      })
      .catch(error => {
        console.error("Error fetching user details", error);
        setLoading(false);
      });
  }, [id]);

  // Gérer le changement dans les champs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userdetails, [name]: value });
  };

  // Gérer la sélection du fichier
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setUserDetails(prevState => ({
      ...prevState,
      profilePicture: file
    }));
  };

  // Gérer la soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();

    const token = Cookies.get('token');

    // Utiliser FormData pour envoyer les données et le fichier
    const formData = new FormData();
    formData.append('firstName', userdetails.firstName);
    formData.append('lastName', userdetails.lastName);
    formData.append('universityName', userdetails.universityName);
    formData.append('email', userdetails.email);
    formData.append('aboutDescription', userdetails.aboutDescription);
    formData.append('profilePicture', userdetails.profilePicture);


    instance.post(`/users/edit`, formData, token)
      .then(response => {
        alert("Profile updated successfully");
        window.location.reload()
      })
      .catch(error => {
        console.error("Error updating profile", error);
      });
  };




  if (loading) {
    return <p>Loading...</p> // Indiquer que les données sont en cours de chargement
  }
  /********************************** update password part */



  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    // Vérifie que le nouveau mot de passe et la confirmation correspondent
    if (newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    try {
      const response = await instance.post('/users/updatePassword', {
        password: password,
        newPassword: newPassword,
      });

      if (response.data.success) {
        setSuccess('Mot de passe mis à jour avec succès');
        setError('');
        handleLogout()
      } else {
        setError('Échec de la mise à jour du mot de passe');
      }
    } catch (err) {
      setError('Erreur lors de la mise à jour du mot de passe');
    }
  };

  return (
    <>
      <TopBar />

      <main className="mt-3">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3">
              <SideEdit />
            </div>

            <div className="col-lg-6 vstack gap-4">
              <div className="tab-content py-0 mb-0">
                <div className="tab-pane show active fade" id="nav-setting-tab-1">
                  <div className="card mb-4">
                    <div className="card-header border-0 pb-0">
                      <h1 className="h5 card-title">Account Settings</h1>
                    </div>

                    <div className="card-body">
                      <form className="row g-3" onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label className="form-label">Profil picture</label>
                          {/* Avatar upload START */}
                          <div className="d-flex align-items-center">
                            <div className="avatar-uploader me-3">
                              {/* Avatar edit */}
                              <div className="avatar-edit">
                                <input
                                  name="profilePicture"

                                  onChange={handleFileChange} type="file" id="avatarUpload" />
                                <label htmlFor="avatarUpload" />
                              </div>
                              {/* Avatar preview */}
                              <div className="avatar avatar-xl position-relative">
                                <img id="avatar-preview" className="avatar-img rounded-circle border border-white border-3 shadow" src={userdetails && userdetails.profilePicture} alt="" />
                              </div>
                            </div>
                            {/* Avatar remove button */}
                            {/* <div className="avatar-remove">
                              <button type="button" id="avatar-reset-img" className="btn btn-light">Delete</button>
                            </div> */}
                          </div>
                          {/* Avatar upload END */}
                        </div>

                        <div className="col-sm-6 col-lg-4">
                          <label className="form-label">First name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={userdetails.firstName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-sm-6 col-lg-4">
                          <label className="form-label">Last name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={userdetails.lastName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-sm-6 col-lg-4">
                          <label className="form-label">University</label>
                          <input
                            type="text"
                            className="form-control"
                            name="universityName"
                            value={userdetails.universityName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-sm-6">
                          <label className="form-label">User name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="username"
                            value={userdetails.username}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-sm-6">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={userdetails.email}
                            onChange={handleChange}
                          />
                        </div>

                        {/* <div className="col-sm-6">
                          <label className="form-label">Phone number</label>
                          <input
                            type="text"
                            className="form-control"
                            name="phoneNumber"
                            value={userdetails.phoneNumber}
                            onChange={handleChange}
                          />
                        </div> */}

                        <div className="col-12">
                          <label className="form-label">About</label>
                          <textarea
                            className="form-control"
                            rows={4}
                            name="aboutDescription"
                            value={userdetails.aboutDescription}
                            onChange={handleChange}
                          />
                          <small>Character limit: 300</small>
                        </div>

                        <div className="col-12 text-end">
                          <button type="submit" className="btn btn-sm btn-primary mb-0">Save changes</button>
                        </div>
                      </form>
                    </div>

                  </div>
                </div>
                {/* Change your password START */}
                <div className="card">
                  <div className="card-header border-0 pb-0">
                    <h5 className="card-title">Change your password</h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleUpdatePassword} className="row g-3">
                      {/* Mot de passe actuel */}
                      <div className="col-12">
                        <label className="form-label">Current password</label>
                        <input
                          type="password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Enter your current password"
                          required
                        />
                      </div>

                      {/* Nouveau mot de passe */}
                      <div className="col-12">
                        <label className="form-label">New password</label>
                        <input
                          type="password"
                          className="form-control"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                          placeholder="Enter new password"
                        />
                      </div>

                      {/* Confirmer le nouveau mot de passe */}
                      <div className="col-12">
                        <label className="form-label">Confirm password</label>
                        <input
                          type="password"
                          className="form-control"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                          placeholder="Confirm new password"
                        />
                      </div>

                      {/* Affichage des erreurs et succès */}
                      {error && <p style={{ color: 'red' }}>{error}</p>}
                      {success && <p style={{ color: 'green' }}>{success}</p>}

                      {/* Bouton pour mettre à jour */}
                      <div className="col-12 text-end">
                        <button type="submit" className="btn btn-primary mb-0">Update password</button>
                      </div>
                    </form>
                  </div>
                </div>
                {/* Card END */}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default EditProfil;



